module.exports = __webpack_public_path__ + "static/media/p_outline.85c74197.svg";